
// Exporterar Highcharts, tillfixad med en initial delay för Highcharts tooltips:

import Highcharts from 'highcharts';


console.log('### Exekverar kod i HighchartsMedInledandeDelayForTooltips (vid import av densamma).');


// Fixa inital delay för Highcharts tooltips:

// Se källa: http://rudovjan.github.io/highcharts-tooltip-delay/

// OBS! Den initiala fördröjningen styrs av den *egna* optionen "delayForDisplay", så här:
// tooltip: {
//		delayForDisplay: 1000
// },
//
// Om den inte är satt sätts fördröjningen till 500 ms.


let timerId = {};

const generatePointsUniqueKey = (points) =>
{

	const generatePointKey = (point) =>
	{
		return point.category + ' ' + point.series.name + ': ' + point.x + ' ' + point.y;
	};

	const result = points.map(generatePointKey).join(', ');

	return result;
}

Highcharts.wrap(Highcharts.Tooltip.prototype, 'refresh', function(proceed)
{
	let seriesName;

	if (Array.isArray(arguments[1]))
	{
		// Can be array in case that, it's shared tooltip
		seriesName = generatePointsUniqueKey(arguments[1]);
	}
	else
	{
		seriesName = arguments[1].series.name;
	}

	const delayForDisplay = (this.chart.options.tooltip.delayForDisplay
		? this.chart.options.tooltip.delayForDisplay
		: 500
	);

	if (timerId[seriesName])
	{
		clearTimeout(timerId[seriesName]);
		delete timerId[seriesName];
	}

	timerId[seriesName] = window.setTimeout(function()	{
			let pointOrPoints = this.refreshArguments[0];

			//if (pointOrPoints === this.chart.hoverPoint || $.inArray(this.chart.hoverPoint, pointOrPoints) > -1)
			if (pointOrPoints === this.chart.hoverPoint || pointOrPoints.indexOf(this.chart.hoverPoint) > -1)
			{
				proceed.apply(this.tooltip, this.refreshArguments);
			}

		}.bind({
			refreshArguments: Array.prototype.slice.call(arguments, 1),
			chart: this.chart,
			tooltip: this
		}),
		delayForDisplay
	);

});



export default Highcharts;


